import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProofDifferentiationMessages } from './ProofDifferentiation.messages';
import { CoinsIcon, LockIcon, GrowthIcon, WandIcon } from '../../design-system/components/SvgIcons';

export const ProofDifferentiation: React.FC = () => {
  const { t } = useTranslation();

  const rows = [
    { competitor: t(ProofDifferentiationMessages.COMPETITORS_HUMAN_SLOW), localingos: t(ProofDifferentiationMessages.LOCALINGOS_LLM_AUTOMATION) },
    { competitor: t(ProofDifferentiationMessages.COMPETITORS_DAYS_WEEKS), localingos: t(ProofDifferentiationMessages.LOCALINGOS_MINUTES_DELIVERY) },
    { competitor: t(ProofDifferentiationMessages.COMPETITORS_MONTHLY_FEES), localingos: t(ProofDifferentiationMessages.LOCALINGOS_PAY_USAGE) },
    { competitor: t(ProofDifferentiationMessages.COMPETITORS_PLACEHOLDER_RISK), localingos: t(ProofDifferentiationMessages.LOCALINGOS_GUARANTEED_PLACEHOLDER) },
  ];

  const proofPoints = [
    { icon: <WandIcon size={36} />, title: t(ProofDifferentiationMessages.POINT_MINUTES_TITLE), desc: t(ProofDifferentiationMessages.POINT_MINUTES_DESC) },
    { icon: <CoinsIcon size={36} />, title: t(ProofDifferentiationMessages.POINT_PAYGO_TITLE), desc: t(ProofDifferentiationMessages.POINT_PAYGO_DESC) },
    { icon: <LockIcon size={36} />, title: t(ProofDifferentiationMessages.POINT_VARIABLE_SAFE_TITLE), desc: t(ProofDifferentiationMessages.POINT_VARIABLE_SAFE_DESC) },
    { icon: <GrowthIcon size={36} />, title: t(ProofDifferentiationMessages.POINT_SCALES_TITLE), desc: t(ProofDifferentiationMessages.POINT_SCALES_DESC) },
  ];

  return (
    <section className="proof-differentiation">
      <div className="container">
        <div className="section-header">
          <h2>{t(ProofDifferentiationMessages.TITLE)}</h2>
          <p className="section-subtitle">{t(ProofDifferentiationMessages.SUBTITLE)}</p>
        </div>

        <div className="proof-points">
          {proofPoints.map((point, i) => (
            <div key={i} className="proof-point">
              <div className="proof-icon" aria-hidden="true">{point.icon}</div>
              <div className="proof-text">
                <h3>{point.title}</h3>
                <p>{point.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="comparison-table-wrapper">
          <table className="comparison-table">
            <thead>
              <tr>
                <th className="comparison-th-competitor">{t(ProofDifferentiationMessages.COMPETITORS_TITLE)}</th>
                <th className="comparison-th-localingos">{t(ProofDifferentiationMessages.LOCALINGOS_TITLE)}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  <td className="comparison-td-competitor">
                    <span className="comparison-mark comparison-mark-no" aria-hidden="true">✗</span>
                    {row.competitor}
                  </td>
                  <td className="comparison-td-localingos">
                    <span className="comparison-mark comparison-mark-yes" aria-hidden="true">✓</span>
                    {row.localingos}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};
